import React from 'react';
import { X, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Sharing Limit Reached Dialog Component
 * Displays when user has reached their member sharing limit
 * Similar to Flutter implementation in viewaccess.dart (lines 255-380)
 */
const SharingLimitDialog = ({ isOpen, onClose, currentCount, maxLimit, planName, upgradeMessage }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    onClose();
    navigate('/portal/subscription');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999] p-4">
      <div className="bg-[#050125] rounded-3xl border border-white/20 max-w-md w-full relative overflow-hidden">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-400 bg-transparent border-none p-1 z-10 transition-colors"
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-8 flex flex-col items-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-[#C99F4A] rounded-full flex items-center justify-center mb-6">
            <Users className="text-white" size={36} />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white text-center mb-4">
            Sharing Limit Reached
          </h2>

          {/* Message */}
          <p className="text-white text-center mb-2 text-base">
            You have reached your {planName} limit of {maxLimit} members ({currentCount}/{maxLimit} used).
          </p>

          {/* Upgrade Message */}
          {upgradeMessage && (
            <p className="text-white/70 text-center mb-6 text-sm whitespace-pre-line px-2">
              {upgradeMessage}
            </p>
          )}

          {/* Upgrade Button */}
          <button
            onClick={handleUpgrade}
            className="w-32 h-12 bg-[#C99F4A] hover:bg-[#D19B15] text-white rounded-xl font-semibold text-base transition-colors"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
};

export default SharingLimitDialog;
